import React from "react";
import { ReactFlow } from "@xyflow/react"; // Ensure you're importing ReactFlow
import DeviceNode from "./components/DeviceNode";
import CollectorNode from "./components/CollectorNode";

import { getTreeLayout } from "../../utils/getTreeLayout";
import {
  AcChargingPole3PhaseOutput,
  BessDeviceOutput,
  CollectorOutputReadable,
  DcChargingPoleOutput,
  ForecastedThreePhaseDeviceOutput,
  SiteConfigurationOutputReadable,
} from "../../../../../services/client/types.gen";
import { useQuery } from "@tanstack/react-query";
import { getLatestMeasurementsForSiteOptions } from "../../../../../services/client/@tanstack/react-query.gen";
import { buildTreeLayout } from "../../utils/buildTreeLayout";

type SiteConfigurationDiagramProps = {
  site_configuration: SiteConfigurationOutputReadable;
  site_id: string;
};

export const SiteConfigurationDiagram: React.FC<
  SiteConfigurationDiagramProps
> = ({ site_configuration, site_id }) => {
  const { data: measurements } = useQuery({
    ...getLatestMeasurementsForSiteOptions({ path: { site_id } }),
  });
  const treeLayout = getTreeLayout(site_configuration);
  const { nodes, edges } = buildTreeLayout(treeLayout);

  return (
    <div style={{ width: "100%", height: 1024 }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        fitView
        minZoom={0.1}
        nodeTypes={{
          collector: ({ data }: { data: CollectorOutputReadable }) => (
            <CollectorNode data={data} measurements={measurements} />
          ),
          device: ({
            data,
          }: {
            data:
              | AcChargingPole3PhaseOutput
              | DcChargingPoleOutput
              | ForecastedThreePhaseDeviceOutput
              | BessDeviceOutput;
          }) => <DeviceNode data={data} measurements={measurements} />,
        }}
      />
    </div>
  );
};

export default SiteConfigurationDiagram;
